export const Modal = {
  content: '',
  active: false,
  open(content) {
    this.content = content;
    this.active = true;
    document.querySelector('#modal a, #modal button, #modal input')?.focus();
  },
  close() {
    // Kill modal contents after fade out
    setTimeout(() => {
      this.content = '';
      this.active = false;
    }, 300);
  }
};
